import api from './client'

export const prospectsApi = {
  list: (params) => api.get('/api/prospects', { params }),

  get: (id) => api.get(`/api/prospects/${id}`),

  create: (data) => api.post('/api/prospects', data),

  update: (id, data) => api.put(`/api/prospects/${id}`, data),

  delete: (id) => api.delete(`/api/prospects/${id}`),

  exportCSV: (params) => api.get('/api/prospects/export', {
    params,
    responseType: 'blob',
  }).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const a = document.createElement('a')
    a.href = url
    a.download = 'prospects.csv'
    a.click()
    window.URL.revokeObjectURL(url)
  }),
}

export const authApi = {
  login: (email, password) =>
    api.post('/api/auth/login', { email, password }),

  register: (email, password, full_name) =>
    api.post('/api/auth/register', { email, password, full_name }),
}
